import { useEffect, useRef } from 'react';
import { formatBarBeat, formatSeconds } from '@/timing/tempoMap';
import { signatureMapOf } from '@/domain/selectors';
import { getServices } from '@/state/services';
import { useDaw } from '@/state/store';

/**
 * Position display. Updated from the audio clock every frame, outside React,
 * for the same reason the playhead is: a component that re-renders sixty times
 * a second drags every sibling with it.
 */
export function TransportReadout(): JSX.Element {
  const project = useDaw((s) => s.project);
  const barRef = useRef<HTMLDivElement>(null);
  const secRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const sigMap = signatureMapOf(project);
    const services = getServices();
    const paint = (ticks: number, seconds: number): void => {
      if (barRef.current) barRef.current.textContent = formatBarBeat(sigMap, ticks);
      if (secRef.current) secRef.current.textContent = formatSeconds(seconds);
    };
    paint(project.transport.playheadTicks, 0);
    return services.playhead.subscribe(paint);
  }, [project]);

  return (
    <div className="readout" aria-label="Playback position">
      <div ref={barRef} className="readout__main">
        1.1.000
      </div>
      <div ref={secRef} className="readout__sub">
        0:00.000
      </div>
    </div>
  );
}
